module.exports = __webpack_public_path__ + "img/1488805325.96eb52ca.jpg";